"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestUrl = exports.fetchExperimentValues = void 0;
const types_1 = require("./request-helpers/types");
const clientError_1 = require("./errors/clientError");
const version_1 = require("../version");
const FetchRequest = __importStar(require("./request-helpers/fetchRequest"));
const types_2 = require("../types");
const safe_timeout_1 = require("./safe-timeout");
const REQUEST_TIMEOUT_MS = 2000;
async function fetchExperimentValues(apiKey, targetApp, identifiers, customAttributes) {
    const requestBody = {
        targetApp,
        identifiers,
        customAttributes
    };
    try {
        const response = await fetch(getRequestUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-node-client',
                'X-Client-Version': version_1.CLIENT_VERSION,
                'X-API-KEY': apiKey
            },
            body: JSON.stringify(requestBody),
            signal: (0, safe_timeout_1.safeTimeoutSignal)(REQUEST_TIMEOUT_MS)
        });
        const bodyString = await FetchRequest.handleResponse(getRequestUrl(), response);
        return extractResponseBody(bodyString);
    }
    catch (error) {
        throw handleError(error);
    }
}
exports.fetchExperimentValues = fetchExperimentValues;
function getRequestUrl() {
    const baseUrl = process.env.MESH_DEPENDENCY_FEATURE_FLAG_SERVICE_BASE_URL;
    if (!baseUrl) {
        throw new clientError_1.ClientError('Service proxy base url MESH_DEPENDENCY_FEATURE_FLAG_SERVICE_BASE_URL environment variable is not configured for your environment.', types_2.RequestErrorKind.IllegalStateException);
    }
    /*
     * Need to ensure that baseUrl ends with a '/' so that the URL constructor does not strip out `/flags` from
     * the MESH_DEPENDENCY_FEATURE_FLAG_SERVICE_BASE_URL env variable set by
     */
    const parsedBaseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';
    return new URL('./api/v2/frontend/experimentValues', parsedBaseUrl).href;
}
exports.getRequestUrl = getRequestUrl;
function handleError(error) {
    const isError = error instanceof Error;
    return isError
        ? error
        : new Error('An unknown error occurred while trying to fetch initialization values for client.');
}
function extractResponseBody(body) {
    const result = types_1.FetcherExperimentsResponseSchema.safeParse(JSON.parse(body));
    if (!result.success) {
        throw new clientError_1.ClientError(`Could not parse request response.`, types_2.RequestErrorKind.BadResponseException);
    }
    return result.data;
}
